import { connect } from 'react-redux';
import MacList from './Mac';
import { getProfile } from '../../actions/homeowner/dashboard';

const mapStateToProps = (state) => {
    return {
        appraiserNumber: state.dashboard.profile.appraiserNumber,
        isFetchingProfile: state.dashboard.fetchingProfile,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getProfile() {
        dispatch(getProfile());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(MacList);